import { Suspense, lazy } from 'react'
import { createBrowserRouter } from 'react-router-dom'
import type { RouteObject as ReactRouterRouteObject } from 'react-router-dom'
import { Spin } from 'antd'
import RootLayout from '@/components/Layout/RootLayout'
import RequireAuth from '@/components/RequireAuth'
import RequireAdmin from '@/components/RequireAdmin'
import { routeMenuConfigs } from './routeConfig'

const AuthLayout = lazy(() => import('@/pages/auth/AuthLayout'))
const AdminLayout = lazy(() => import('@/pages/admin/AdminLayout'))

const pageFallback = (
    <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '6rem' }}>
        <Spin />
    </div>
)

function toRouteObject(r: typeof routeMenuConfigs[number]): ReactRouterRouteObject {
    const Comp = r.component as React.ComponentType
    let element = <Suspense fallback={pageFallback}><Comp /></Suspense>
    if (r.requireAuth) element = <RequireAuth>{element}</RequireAuth>
    if (r.requireAdmin) element = <RequireAdmin>{element}</RequireAdmin>
    if (r.path === '') return { index: true, element, handle: r.handle }
    return { path: r.path, element, handle: r.handle }
}

const rootRoutes = routeMenuConfigs.filter(r => r.component && r.layout !== 'auth' && r.layout !== 'admin' && r.layout !== 'blank').map(toRouteObject)
const authRoutes = routeMenuConfigs.filter(r => r.component && r.layout === 'auth').map(toRouteObject)
const adminRoutes = routeMenuConfigs.filter(r => r.component && r.layout === 'admin').map(toRouteObject)
// blank 布局：无任何框架元素（无侧栏/顶栏），认证保护仍由路由级 RequireAdmin 提供
const blankRoutes = routeMenuConfigs.filter(r => r.component && r.layout === 'blank').map(toRouteObject)

export const appRoutes = rootRoutes

const router = createBrowserRouter([
    {
        path: '/',
        element: <RootLayout />,
        children: rootRoutes,
    },
    {
        path: '/',
        element: <Suspense fallback={pageFallback}><AuthLayout /></Suspense>,
        children: authRoutes,
    },
    {
        path: '/',
        element: <Suspense fallback={pageFallback}><AdminLayout /></Suspense>,
        children: adminRoutes,
    },
    {
        path: '/',
        children: blankRoutes,
    },
])

export default router
